import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { get } from "../../utils/localStorage";
import { isEmpty as isStringEmpty } from "../../utils/string";
import { getPostAuthRedirectUrl } from "../../utils/redirectUtils";

export default function Landing() {
  const navigate = useNavigate();

  useEffect(() => {
    const accessToken = get("token");
    const refreshToken = get("refreshToken");
    const userRole = get("userRole");
    const agencyId = get("agency_id");

    if (!isStringEmpty(accessToken) || !isStringEmpty(refreshToken)) {
      // Use the redirect utility to determine where to navigate
      const redirectUrl = getPostAuthRedirectUrl(userRole, agencyId);
      navigate(redirectUrl);
      return;
    }

    navigate("/employee-login");
  }, []);
}
